module.exports = __webpack_public_path__ + "assets/img/33_841.59e18f07.jpg";